import React from 'react';

const LoginAnimation = () => {
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-white/30 dark:bg-dark-900/30 backdrop-blur-xl animate-in fade-in duration-500">
            {/* Background floating glows */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary-500/10 rounded-full blur-[100px] animate-pulse" />
                <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-[120px] animate-pulse transition-all duration-1000" />
            </div>

            <div className="relative flex flex-col items-center">
                {/* Text Logo Animation */}
                <div className="relative mb-8 text-center">
                    <div className="flex items-center justify-center gap-1 animate-in zoom-in-75 duration-700">
                        <span className="text-6xl md:text-7xl font-black tracking-tight text-primary-600 drop-shadow-sm">
                            Books
                        </span>
                        <span className="text-6xl md:text-7xl font-black tracking-tight bg-gradient-to-r from-primary-600 to-cyan-500 bg-clip-text text-transparent drop-shadow-sm">
                            Comply
                        </span>
                    </div>
                    {/* Floating decorative underline */}
                    <div className="h-1.5 w-full bg-gradient-to-r from-primary-600 to-cyan-500 rounded-full mt-2 animate-in slide-in-from-left duration-700 delay-200" />
                </div>

                {/* Loading Text */}
                <div className="flex flex-col items-center gap-3">
                    <h2 className="text-2xl font-bold bg-gradient-to-r from-primary-600 to-cyan-500 bg-clip-text text-transparent animate-in slide-in-from-bottom-2 duration-700 delay-200">
                        Preparing your dashboard
                    </h2>
                    
                    {/* Progress dots */}
                    <div className="flex gap-1.5 pt-2">
                        {[0, 1, 2].map((i) => (
                            <div 
                                key={i}
                                className="w-2 h-2 bg-primary-500 rounded-full animate-bounce"
                                style={{ animationDelay: `${i * 150}ms` }}
                            />
                        ))}
                    </div>
                </div>
            </div>

            <style jsx>{`
                @keyframes shimmer {
                    100% { transform: translateX(100%); }
                }
                .animate-shimmer {
                    animation: shimmer 2s infinite;
                }
                .animate-spin-slow {
                    animation: spin 8s linear infinite;
                }
            `}</style>
        </div>
    );
};

export default LoginAnimation;
